(function () {
  let global = {
    copiedState: 0,
    // Replaced on DOMContentLoaded when the offer popup exists.
    renderCopiedText: function () {}
  }

  class ProgressBar extends HTMLElement {
      constructor() {
          super();
      }

      connectedCallback() {
          this.setupEvents();
      }

      setupEvents() {
          this.addEventListener('update', this.handleUpdate.bind(this)); 
          this.initOffer();
      }

      handleUpdate(e) {
          const cartData = e.detail?.cart;
          if (!cartData) return;
          const frontier = +this.dataset.frontier;
          this.updateMessage(cartData.total_price, frontier);
          this.showOffer(cartData.total_price, frontier);

          const fillEl = this.querySelector('.progress-bar__fill');

          if (fillEl) {
            const percent = Math.min(100, (cartData.total_price / frontier) * 100);
            fillEl.style.width = `${percent}%`;
          }
      }

      updateMessage(totalPrice, frontier) {
          const messageElSuccess = this.querySelector('.progress-bar__message--success');
          const messageElProgress = this.querySelector('.progress-bar__message--progress');
          if (!messageElSuccess || !messageElProgress) return;

          if (totalPrice >= frontier) {
              messageElSuccess.classList.remove('display-none');
              messageElProgress.classList.add('display-none');
          } else {
              const remainingBoard = messageElProgress.querySelector('.remaining-amount-board');
              remainingBoard.textContent = ((frontier - totalPrice)/100).toFixed(2) + " ₪ ";
              messageElSuccess.classList.add('display-none');
              messageElProgress.classList.remove('display-none');
          }
      }

      initOffer() {
        const price = this.getAttribute('data-initial');
        const frontier = this.getAttribute('data-frontier');

        if (price < frontier) {
          sessionStorage.setItem('_discount_offer', 'false');
          global.copiedState = 0;
          global.renderCopiedText();
        }
      }

      // The OFF7 coupon popup is retired: reaching the threshold now only unlocks free shipping.
      showOffer(totalPrice, frontier) {
        return;
      }
  }

  if (!customElements.get('progress-bar')) {
    customElements.define('progress-bar', ProgressBar);
  }


  document.addEventListener('DOMContentLoaded', function() {

      const couponCodeButton = document.querySelector(".offer-popup__code-copy");
      const copiedMsg = document.querySelector(".copied-msg");
      const copyMsg = document.querySelector(".copy-msg-text");

      if (couponCodeButton && copiedMsg) {
        [couponCodeButton, copyMsg].forEach(x => x.addEventListener('click', function (e) {
          const code = couponCodeButton.getAttribute('data-code');

          if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(() => {
              global.copiedState = 1;
              global.renderCopiedText();
            }).catch(err => {
            });
          }
        }));

    function renderCopiedText() {
      if (global.copiedState == 1) {
        couponCodeButton.classList.add('copied');
        copiedMsg.classList.remove('display-none');
        copyMsg.classList.add('display-none');
      } else {
        couponCodeButton.classList.remove('copied');
        copiedMsg.classList.add('display-none');
        copyMsg.classList.remove('display-none');
      }
      }

      global.renderCopiedText = renderCopiedText;
    }
  })


})()
